import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
import { ILesson } from 'interface/lesson';
import { isStatusNegative } from 'utils';
import Rating from './Rating';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core';
import houstonPallete from 'assets/houstonPallete';
import { CourseTheme } from 'assets/themes/Course';

interface IProps {
  lesson: ILesson;
}

const useStyles = makeStyles<CourseTheme>((theme) => ({
  lessonInfoContainer: {
    maxWidth: 1260,
    margin: 'auto',
    padding: '0 20px',
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('md')]: {
      padding: 0,
    },
  },
  titleContainer: {
    '& > p': {
      color: 'white',
      fontSize: 24,
      maxWidth: 600,
      [theme.breakpoints.down('md')]: {
        fontSize: 16,
        fontWeight: 600,
        maxWidth: 400,
        paddingLeft: 20,
      },
    },
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
  lessonInfo: {
    background: houstonPallete.grey[500],
    padding: '20px 0',
  },
  lessonName: {
    fontSize: 16,
  },
  authorContainer: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 12,
    gap: '16px',
    '& > p': {
      color: 'white',
      fontSize: 20,
      maxWidth: 600,
      fontWeight: 600,
    },
    [theme.breakpoints.down('md')]: {
      marginLeft: '16px',
    },
  },
  authorPhoto: {
    width: 40,
    height: 40,
    background: houstonPallete.grey[600],
    borderRadius: 90,
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& > p': {
      color: houstonPallete.primary.contrastText,
    },
  },
}));

const LessonActions = (props: IProps) => {
  const classes = useStyles({});

  const getFirstLetter = (author: string) => author.split('')[0];

  if (!props.lesson.id) {
    return null;
  }

  const statusNegative = isStatusNegative(props.lesson.status);

  return (
    <Grid container className={classes.lessonInfo}>
      <Hidden xsDown>
        <Divider />
      </Hidden>
      <Grid className={classes.lessonInfoContainer} container spacing={2}>
        <Grid>
          <Grid className={classes.titleContainer} item xs={12} container justifyContent='space-between' sm={true}>
            <Typography id='lesson-lesson-name' className={classes.lessonName}>
              {props.lesson.title}
            </Typography>

            {!statusNegative && <div>{!props.lesson.disable_ratings && <Rating />}</div>}
          </Grid>
        </Grid>
        {!statusNegative && (
          <Grid className={classes.authorContainer} container spacing={2}>
            <Grid className={classes.authorPhoto}>
              {props.lesson.author.avatar && props.lesson.author.avatar != '' ? (
                <img src={props.lesson.author.avatar} alt='Imagem do autor' />
              ) : (
                <Typography id='lesson-lesson-name' className={classes.lessonName}>
                  {getFirstLetter(props.lesson.author.name)}
                </Typography>
              )}
            </Grid>
            <Typography id='lesson-lesson-name' className={classes.lessonName}>
              {props.lesson.author.name}
            </Typography>
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};

export default LessonActions;
